"use client";

import { useEffect } from "react";
import { Button } from "@/components/shadcn/button";
import { isChunkLoadError, reloadForChunkError } from "@/lib/chunk-error/is-chunk-error";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (isChunkLoadError(error)) {
      reloadForChunkError();
    }
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-4 text-center">
      <h2 className="text-h4 font-semibold text-foreground">
        Etwas ist schiefgelaufen
      </h2>
      <p className="text-body text-foreground-subtle">
        Ein unerwarteter Fehler ist aufgetreten.
      </p>
      <div className="flex gap-2">
        <Button onClick={() => reset()}>Erneut versuchen</Button>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Seite neu laden
        </Button>
      </div>
    </div>
  );
}
